/** URL base del directorio público Vitrina Virtual (app Vite separada). */
export function vitrinaPublicUrl(): string {
  const raw = (
    process.env.REACT_APP_VITRINA_PUBLIC_URL ||
    process.env.REACT_APP_VITRINA_URL ||
    'http://localhost:5180'
  ).trim();
  return raw.replace(/\/$/, '');
}
